import { render } from "./PlaceContact.vue?vue&type=template&id=11f1e40a&ts=true"
import script from "./PlaceContact.vue?vue&type=script&lang=ts"
export * from "./PlaceContact.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__